export default {
  notification: {},
}
